/**
 * Small status pills for the Studies tab (plan §11 tab 2). Color is paired
 * with the label text itself (never color alone, per the design skill).
 */
import type { NegotiationStatus } from '../../api/client';

const NEGOTIATION_STATUS_META: Record<NegotiationStatus, { label: string; cls: string }> = {
  open: {
    label: 'Open',
    cls: 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-400',
  },
  agreed: {
    label: 'Agreed',
    cls: 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400',
  },
  executed: {
    label: 'Executed',
    cls: 'bg-green-50 text-green-700 dark:bg-green-900/20 dark:text-green-400',
  },
  closed: {
    label: 'Closed',
    cls: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300',
  },
};

export function NegotiationStatusPill({ status }: { status: NegotiationStatus }) {
  const meta = NEGOTIATION_STATUS_META[status] ?? { label: status, cls: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300' };
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${meta.cls}`}>
      {meta.label}
    </span>
  );
}

/** Study status has no fixed enum (plan §5.3); render whatever text is stored, with 'open' hinted as active. */
export function StudyStatusPill({ status }: { status: string }) {
  const cls =
    status === 'closed'
      ? 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'
      : 'bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-400';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${cls}`}>
      {status}
    </span>
  );
}
